import Component from '../../component/component';

import './textfield.scss';

export default class Textfield extends Component {
    static initSelector: string = '.textfield--clear';

    readonly input: JQuery;
    readonly trigger: JQuery;

    constructor(target: HTMLElement) {
        super(target);
        this.input = this.element.find('input');
        this.trigger = this.element.find('.textfield__clear');

        this.trigger.on('click', this.handleCLearClick.bind(this));
    }

    handleCLearClick(): void {
        this.input.attr('value', '');
        this.input.get(0).focus();
    }
}
